// extracted by mini-css-extract-plugin
export default {"skeleton_loader_container":"skeleton-loader_skeleton_loader_container__vaoUk"};